/**
 * Single code point allowed in person-name fields: letters (any script),
 * combining marks, common separators used in legal names.
 */
const PERSON_NAME_CODE_POINT = /^[\p{L}\p{M} \u00A0'\u2019.-]$/u;

/**
 * Removes characters that are not typically valid in a person's name.
 * Aligns loosely with common payroll / onboarding name rules (letters,
 * spaces, hyphen, apostrophe types, period e.g. "St.").
 */
export const sanitizePersonNameInput = (value: string): string => {
  let result = "";
  for (const char of value) {
    if (PERSON_NAME_CODE_POINT.test(char)) {
      result += char;
    }
  }
  return result;
};
